import { jsxs, jsx } from "react/jsx-runtime";
const IconNoteSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsxs("g", { stroke: "currentColor", fill: "none", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12.73 1.5H3c-.414 0-.79.168-1.06.44A1.49 1.49 0 0 0 1.5 3v18c0 .414.168.79.44 1.06.27.272.646.44 1.06.44h12c.414 0 .79-.168 1.06-.44.272-.27.44-.646.44-1.06V5.772L12.73 1.5Z",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M16.357 6H13a1 1 0 0 1-1-1V2c0-.552.203-.813.755-.813" }),
        /* @__PURE__ */ jsx("rect", { x: 4, y: 8, width: 10, height: 1, rx: 0.5, fill: "currentColor" }),
        /* @__PURE__ */ jsx("rect", { x: 4, y: 11, width: 10, height: 1, rx: 0.5, fill: "currentColor" }),
        /* @__PURE__ */ jsx("rect", { x: 4, y: 14, width: 10, height: 1, rx: 0.5, fill: "currentColor" }),
        /* @__PURE__ */ jsx("rect", { x: 6, y: 17, width: 6, height: 1, rx: 0.5, fill: "currentColor" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M21 1.5c-.414 0-.79.168-1.06.44A1.49 1.49 0 0 0 19.5 3v15.5h3V3c0-.414-.168-.79-.44-1.06A1.495 1.495 0 0 0 21 1.5Zm1.694 17h-3.388l1.695 5.081 1.693-5.081Z",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M19 10h4v1h-4z" })
      ] })
    ]
  }
);
export {
  IconNoteSvg
};
